<template>
  <div class="share-box">
    <div class="share-inner clearfix">
      <!-- <div v-if="!isWechat" class="item">
        <img src="@images/icon_sinaweibo.png" alt="微博" class="icon-img" @click="shareToSinaWB" />
      </div> -->
      <div class="item">
        <img src="@images/icon_wechat.png" alt="微信" class="icon-img" @click="shareToWechat" />
      </div>
      <div class="item">
        <img src="@images/icon_qq.png" alt="QQ" class="icon-img" @click="shareToQQ" />
      </div>
      <!-- <div class="item">
        <img src="@images/icon_tencentweibo.png" alt="腾讯微博" class="icon-img" @click="shareToQQwb" />
      </div> -->
      <div class="item">
        <img src="@images/icon_qzone.png" alt="QQ空间" class="icon-img" @click="shareToQzone" />
      </div>
      <div class="item">
        <img src="@images/icon_douban.png" alt="豆瓣" class="icon-img" @click="shareToDouban" />
      </div>
    </div>
  </div>
</template>

<script>
import { verify } from '@/utils'

export default {
  name: 'ShareBox',
  props: {
    shareData: Object
  },
  data () {
    return {
      winWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
      title: '',
      pic: '',
      desc: '',
      summary: '',
      source: '',
      sourceUrl: '',
      showcount: '',
      site: 'Absolut Nights 100',
      width: 600,
      height: 600,
      top: '100',
      left: '',
      url: window.location.href,
      isWechat: verify.isWeixin()
    }
  },
  methods: {
    // 分享到微信
    shareToWechat () {
      this.$emit('shareToWx')
    },
    // 分享到新浪微博
    shareToSinaWB (event) {
      event.preventDefault()
      var _shareUrl = 'http://v.t.sina.com.cn/share/share.php?&appkey=895033136'; //真实的appkey，必选参数
      _shareUrl += '&url=' + encodeURIComponent(this.url); //参数url设置分享的内容链接|默认当前页location，可选参数
      _shareUrl += '&title=' + encodeURIComponent(this.title); //参数title设置分享的标题|默认当前页标题，可选参数
      _shareUrl += '&source=' + encodeURIComponent(this.source || '');
      _shareUrl += '&sourceUrl=' + encodeURIComponent(this.sourceUrl || '');
      _shareUrl += '&content=' + 'utf-8'; //参数content设置页面编码gb2312|utf-8，可选参数
      _shareUrl += '&pic=' + encodeURIComponent(this.pic || ''); //参数pic设置图片链接|默认为空，可选参数
      window.open(_shareUrl, '_blank', 'width=' + this.width + ',height=' + this.height + ',top=' + this.top + ',left=' + this.left + ',toolbar=no,menubar=no,scrollbars=no, resizable=1,location=no,status=0');
    },
    // 分享到QQ
    shareToQQ (event) {
      event.preventDefault();
      var _shareUrl = 'http://connect.qq.com/widget/shareqq/index.html?';
      _shareUrl += 'url=' + encodeURIComponent(this.url); //参数url设置分享的内容链接|默认当前页location
      _shareUrl += '&desc=' + encodeURIComponent(this.desc); //参数desc设置分享的描述，可选参数
      _shareUrl += '&summary=' + encodeURIComponent(this.summary); //参数summary设置分享摘要，可选参数
      _shareUrl += '&title=' + encodeURIComponent(this.title); //参数title设置分享标题，可选参数
      _shareUrl += '&pics=' + encodeURIComponent(this.pic || ''); //参数pics设置分享图片的路径，多张图片以＂|＂隔开，可选参数
      window.open(_shareUrl, '_blank', 'width=' + this.width + ',height=' + this.height + ',top=' + this.top + ',left=' + this.left + ',toolbar=no,menubar=no,scrollbars=no,resizable=1,location=no,status=0');
    },
    // 分享到QQ空间
    shareToQzone (event) {
      event.preventDefault();
      var _shareUrl = 'http://sns.qzone.qq.com/cgi-bin/qzshare/cgi_qzshare_onekey?';
      _shareUrl += 'url=' + encodeURIComponent(this.url); //参数url设置分享的内容链接|默认当前页location
      _shareUrl += '&showcount=' + this.showcount || 0; //参数showcount是否显示分享总数,显示：'1'，不显示：'0'，默认不显示
      _shareUrl += '&desc=' + encodeURIComponent(this.desc); //参数desc设置分享的描述，可选参数
      _shareUrl += '&summary=' + encodeURIComponent(this.summary); //参数summary设置分享摘要，可选参数
      _shareUrl += '&title=' + encodeURIComponent(this.title); //参数title设置分享标题，可选参数
      _shareUrl += '&site=' + encodeURIComponent(this.site || ''); //参数site设置分享来源，可选参数
      _shareUrl += '&pics=' + encodeURIComponent(this.pic || ''); //参数pics设置分享图片的路径，多张图片以＂|＂隔开，可选参数
      window.open(_shareUrl, '_blank', 'width=' + this.width + ',height=' + this.height + ',top=' + this.top + ',left=' + this.left + ',toolbar=no,menubar=no,scrollbars=no,resizable=1,location=no,status=0');
    },
    // 分享到豆瓣
    shareToDouban (event) {
      event.preventDefault();
      var _shareUrl = 'http://shuo.douban.com/!service/share?';
      _shareUrl += 'href=' + encodeURIComponent(this.url); //分享的链接
      _shareUrl += '&name=' + encodeURIComponent(this.title); //分享的标题
      _shareUrl += '&image=' + encodeURIComponent(this.pic || ''); //分享的图片
      window.open(_shareUrl, '_blank', 'width=' + this.width + ',height=' + this.height + ',left=' + this.left + ',top=' + this.top + ',toolbar=no,menubar=no,scrollbars=no,resizable=1,location=no,status=0');
    },
    // 分享到腾讯微博
    shareToQQwb (event) {
      event.preventDefault();
      var _shareUrl = 'http://v.t.qq.com/share/share.php?';
      _shareUrl += 'title=' + encodeURIComponent(this.title); //分享的标题
      _shareUrl += '&url=' + encodeURIComponent(this.url); //分享的链接
      _shareUrl += '&appkey=5bd32d6f1dff4725ba40338b233ff155'; //在腾迅微博平台创建应用获取微博AppKey
      _shareUrl += '&site=' + encodeURIComponent(this.site || ''); //分享来源
      _shareUrl += '&pic=' + encodeURIComponent(this.pic || ''); //分享的图片，如果是多张图片，则定义var _pic='图片url1|图片url2|图片url3....'
      window.open(_shareUrl, '_blank', 'width=' + this.width + ',height=' + this.height + ',left=' + this.left + ',top=' + this.top + ',toolbar=no,menubar=no,scrollbars=no,resizable=1,location=no,status=0');
    }
  },
  mounted () {
    this.left = this.winWidth / 2
    this.title = this.shareData.title
    this.pic = this.$apiConfig.host + this.shareData.pic
    this.desc = this.shareData.desc
    this.summary = this.shareData.summary
  }
}
</script>

<style lang="scss" scoped>
.share-box {
  position: absolute;
  z-index: 10;
  .share-inner {
    // width: 100%;
    width: 100px;
    text-align: left;
    font-size: 0;
    .item {
      display: inline-block;
      width: 25%;
      padding: 10px 14px;
      cursor: pointer;
      .icon-img {
        width: 100%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ShareBox.vue